import { render, staticRenderFns } from "./SwiperContainer2.vue?vue&type=template&id=542a1875&scoped=true"
import script from "./SwiperContainer2.vue?vue&type=script&lang=js"
export * from "./SwiperContainer2.vue?vue&type=script&lang=js"
import style0 from "./SwiperContainer2.vue?vue&type=style&index=0&id=542a1875&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a1875",
  null
  
)

export default component.exports